import { Component } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'postbid-opt-out-component',
  templateUrl: './postbid-opt-out.component.html',
  styleUrls: ['./postbid-opt-out.component.scss']
})

export class PostbidOptOutComponent {

  constructor(public sharedService: SharedService, public modalsService: ModalsService) { }

  confirmOptOut() {
    this.sharedService.sendMessage('CONFIRM_OPT_OUT');
    this.modalsService.hideModal();
  }

}
